<template>
    <div class="notification-container">
        <div class="notification" v-bind:class="[n.type, n.hidden]" v-for="n in notifications" @mouseenter="cancelRemove(n.id)" @mouseleave="startRemove(n.id)" v-bind:key="n.id" v-on:click="remove(n.id)">
            <div class="notification-inner">
                <span>{{ n.msg }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { Events } from '@/events.js'

export default {
    name: 'Notifications',
    data: function() {
        return {
            notifications: [],
            count: 0
        }
    },
    mounted() {
        Events.$on('addNotification', (payload) => {
            let type = payload.type
            let msg = payload.msg
            let timeout = payload.timeout
            this.add(type, msg, timeout)
        })
    },
    methods: {
        add(type, msg, timeout) {
            let id = this.count++
            this.notifications.push({'id': id, 'type': type, 'msg': msg, 'hidden': '', 'timeoutId': null, 'timeout': timeout})
            this.startRemove(id)
        },
        cancelRemove(id) {
            for (let i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].id == id && this.notifications[i].timeoutId != null) {
                    clearTimeout(this.notifications[i].timeoutId)
                    this.notifications[i].timeoutId = null
                    break
                }
            }
        },
        startRemove(id) {
            for (let i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].id == id && this.notifications[i].timeoutId == null) {
                    if (this.notifications[i].timeout == 0) {
                        break;
                    } else if (this.notifications[i].timeout == undefined || this.notifications[i].timeout == null) {
                        this.notifications[i].timeout = 5
                    }

                    this.notifications[i].timeoutId = setTimeout(() => { this.remove(id) }, this.notifications[i].timeout * 1000)
                    break
                }
            }
        },
        remove(id) {
            for (let i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].id == id) {
                    this.notifications[i].hidden = 'hidden'
                    setTimeout(() => { this.notifications.splice(i, 1) }, 300)
                    break
                }
            }
        }
    }
}
</script>

<style scoped lang="sass">
@import '@/styles/default.sass'

.notification-container
    position: fixed
    bottom: 10px
    left: 0
    width: 100%
    z-index: 9000
    pointer-events: none

.notification
    position: relative
    width: 350px
    min-height: 40px
    margin-bottom: 15px
    margin: 0 30px 15px
    border-radius: 3px
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3)
    color: white
    transition: all 0.3s linear
    pointer-events: all
    background: #007bff
    font-family: $font-family
    font-size: $font-size

    &.hidden
        opacity: 0

    &:hover
        cursor: pointer

    &.success
        background: #28a745

    &.error
        background: #dc3545

    &.info
        background: #17a2b8

    &.warning
        background: #ffc107
        color: $color

    .notification-inner
        padding: 20px
</style>
